/**
 * Legenda sempre visibile dei codici turno (su touch il tooltip `title` delle celle non si vede).
 * Colori allineati a getShiftInfoForDate (OssTurni) e cellInfo (OssTurniGestione).
 */
export const OSS_TURNI_LEGENDA = [
  { code: "M", label: "Mattina", bg: "bg-sky-200", text: "text-sky-900" },
  { code: "P", label: "Pomeriggio", bg: "bg-rose-200", text: "text-rose-900" },
  { code: "P*", label: "Pomeriggio corto", bg: "bg-fuchsia-200", text: "text-fuchsia-900", personal: true },
  { code: "M-P", label: "Lunga", bg: "bg-emerald-300", text: "text-emerald-900" },
  { code: "N", label: "Notte", bg: "bg-slate-300", text: "text-slate-800" },
  { code: "S", label: "Smontante", bg: "bg-indigo-200", text: "text-indigo-900" },
  { code: "R", label: "Riposo", bg: "bg-violet-200", text: "text-violet-900" },
  { code: "F", label: "Ferie", bg: "bg-amber-200", text: "text-amber-900" },
];

export default function OssTurniLegend({ personal = false, className = "" }) {
  const items = OSS_TURNI_LEGENDA.filter((i) => personal || !i.personal);
  return (
    <ul aria-label="Legenda turni" data-testid="oss-turni-legenda" className={`flex flex-wrap gap-x-4 gap-y-2 text-sm text-slate-700 ${className}`}>
      {items.map((i) => (
        <li key={i.code} className="flex items-center gap-2">
          <span className={`inline-flex h-7 min-w-[28px] items-center justify-center rounded-md px-1 text-xs font-bold ${i.bg} ${i.text}`}>{i.code}</span>
          {i.label}
        </li>
      ))}
    </ul>
  );
}
